class EjanseEmailForm extends HTMLElement {
  #abort = new AbortController();

  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="email"]');
    this.button = this.querySelector('button[type="submit"]');
    this.message = this.querySelector('[data-ejanse-email-message]');
    this.success = this.querySelector('[data-ejanse-email-success]');
    this.form.addEventListener('submit', (event) => this.#onSubmit(event), { signal: this.#abort.signal });
    this.input.addEventListener('input', () => this.#setError(false), { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort.abort();
  }

  reset() {
    this.form.hidden = false;
    this.form.style.display = '';
    this.success.hidden = true;
    this.form.reset();
    this.#setError(false);
  }

  #setError(show) {
    this.input.setAttribute('aria-invalid', String(show));
    this.message.textContent = show ? this.dataset.textError : '';
  }

  async #onSubmit(event) {
    event.preventDefault();
    if (!this.input.value.trim() || !this.input.checkValidity()) {
      this.#setError(true);
      this.input.focus();
      return;
    }

    this.button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(this.form.action, {
        method: 'POST',
        body: new FormData(this.form),
        headers: { Accept: 'text/html' },
      });

      // Shopify may ask for a captcha; let the browser do a normal submit so the person can solve it.
      if (response.url.includes('/challenge')) {
        HTMLFormElement.prototype.submit.call(this.form);
        return;
      }

      if (response.url.includes('customer_posted=true')) {
        this.form.hidden = true;
        this.success.hidden = false;
        this.success.focus({ preventScroll: true });
        return;
      }

      this.#setError(true);
    } catch (error) {
      console.error(error);
      this.#setError(true);
    } finally {
      this.button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('ejanse-email-form')) customElements.define('ejanse-email-form', EjanseEmailForm);
